import { Heading } from "@chakra-ui/react";

export default function () {
  return (
    <div>
      <Heading m="50px 0 50px 100px">Hot Deals</Heading>
    </div>
  );
}
